import React from "react";
import PropTypes from "prop-types";
import { useHistory, useLocation } from "react-router-dom";
import * as CONST from "../Constants";
import * as API from "../api";


export default function PatientAlert(props) {
  console.log(props.alerts[0]);
  let alert = props.alerts[0];
  const [show, setShow] = React.useState(true);
  const history = useHistory();
  return (show == true && <>
    <div className='patient-alert-container'>
      <div className='inner-container'>
        <div className='m-t-lg'>
          <h4><i className='blue-text fa fa-exclamation-circle'></i> {alert.title}</h4>
          <div
            dangerouslySetInnerHTML={{
              __html: alert.body,
          }}>
          </div>
          <div className='m-t-lg'>
            <a onClick={(el) => {
                setShow(false);
                history.push(alert.link);
              }}
              className='btn blue-btn-filled'
            > <i className='fa fa-check-circle m-r-lg'></i> {alert.action_text}</a>
          </div>
        </div>
      </div>
    </div>
  </>)
};
